import React from "react"
import styled, { css } from "styled-components"
import HomePageTitle from "../homePageTitle/homePageTitle"
import LinkContainer from "../linkContainer/linkContainer"

const BlockContainer = ({
  to,
  title,
  children,
  className = `random`,
  ...props
}) => {
  return (
    <>
      <Container className={className} to={to} {...props}>
        {title && <Title>{title}</Title>}
        {children}
      </Container>
    </>
  )
}

const commonStyle = css`
  margin-bottom: 50px;
  background-color: #00a1cc;
  padding: 30px;
  box-sizing: border-box;
  border-radius: 10px;
  display: inline-block;
  text-decoration: none;
  color: white;
  font-size: 24px;
  width: 100%;
`

const Container = styled(LinkContainer)`
  ${commonStyle}
`
export const Title = styled(HomePageTitle)`
  margin-bottom: 10px;
  color: white;
`
export default BlockContainer
